import {
  FETCH_STATISTICS_FORM_FAIL,
  FETCH_STATISTICS_FORM_REQUEST,
  FETCH_STATISTICS_FORM_SUCCESS,
} from "../../ActionType/statisticsTypes/StatisticsTypes";

export const getStatisticsReducer = (
  state = { loading: true, statistics: [],total:0, error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_STATISTICS_FORM_REQUEST:
      return {
        loading: true,
      };
    case FETCH_STATISTICS_FORM_SUCCESS:
      return {
        loading: false,
        statistics: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_STATISTICS_FORM_FAIL:
      return {
        loading: false,
        statistics: [],
        error: "",
      };
    default:
      return state;
  }
};
